import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To216(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMediaObjectRatio1To216"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M1 4a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm7.013-.5a.5.5 0 0 1 .5-.5h5.98a.5.5 0 1 1 0 1h-5.98a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h5.98a.5.5 0 1 1 0 1h-5.98a.5.5 0 0 1-.5-.5m.5-2.5a.5.5 0 0 0 0 1H12.1a.5.5 0 1 0 0-1zm-.5 4.5a.5.5 0 0 1 .5-.5H12.1a.5.5 0 1 1 0 1H8.513a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To216);
